import React from 'react'
import classNames from 'classnames'

import { useStateContext } from '@zambezi/caballo-vivo'

import ConsentListSectionHeader from './ConsentListSectionHeader'
import VrpTppCard, { EmptyVrpTppCard } from './VrpTppCard'

import layoutStyle from '../common/api-enabler-styles.module.css'

export default function VrpTppS() {
  const vrp = useStateContext().get('vrp')
  return (
    <div className="js-tpp-list">
      <VrpTppSection
        label="Connected"
        description="Apps and websites who have permission to make recurring payments."
        tpps={vrp.get('activeTpps')}
        className="js-active-section"
        pointedBorder
      />

      <VrpTppSection
        label="Disconnected"
        description="History of apps and websites who had permission to make recurring payments."
        tpps={vrp.get('inactiveTpps')}
        className="js-inactive-section"
      />
    </div>
  )
}

function VrpTppSection({ label, description, tpps, className, pointedBorder }) {
  return (
    <section className={classNames(layoutStyle.overviewSection, className)}>
      <ConsentListSectionHeader
        count={tpps.size}
        label={label}
        description={description}
        consentType="vrp"
        indented
        pointedBorder={pointedBorder}
      />
      {tpps.size > 0 ? (
        tpps
          .valueSeq()
          .map((tpp, index) => (
            <VrpTppCard
              key={tpp.get('clientId')}
              tpp={tpp}
              index={index}
              consentType="vrp"
            />
          ))
          .toArray()
      ) : (
        <EmptyVrpTppCard label={label} />
      )}
    </section>
  )
}
